export const environment = {
  production: false,
  hmr: false,
  title: 'Dev Environment Heading',
  apiURL: 'https://ant-api-dev.broetchen.taxi/api/',
  mollieAuthRedirectUri: "https://ant-commander-dev.broetchen.taxi/settings",
  QrUrl: "https://ant-app-dev.broetchen.taxi",
};
